import User from "../../models/User";
export var setCurrentUser = function setCurrentUser(state, payload) {
  state.currentUser = payload ? new User(payload) : null;
};